module.exports = __webpack_public_path__ + "img/texture.7ff8dfac.png";